export const GET_MAX_TARGET_SCORE = "getMaxTargetScore";
export const GET_CAN_VIEW_PEERS = "getCanViewPeers";

export const GET_MEMBER_POSITIONS = "getMemberPositions";
export const GET_TARGETS_HISTORY = "getTargetsHistory";

export const FETCH_AVAILABLE_HEADS = "fetchAvailableHeads";
